export default "__VITE_ASSET__DoVbWSI3__"